<template>
  <!-- https://michalsnik.github.io/aos/ -->
  <v-container>

    <v-card v-if="setFoundForThisHour==0" class="mx-auto" max-width="550">
      <v-row class="d-flex justify-center align-center text-h5 text-center ma-1 pa-1 grey--text"> XXXX   <v-progress-circular
        size=20
        :width="3"
        color="blue-lighten-3"
      indeterminate
    ></v-progress-circular>
      Looking up Set for {{currentHour}}:00
      </v-row>
      <v-divider></v-divider>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="pink darken-2 white--text" @click="goTo('sets')">Select a different session</v-btn>
        <v-spacer></v-spacer>        
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="pink darken-2 white--text" @click="goTo('home')">Cancel</v-btn>
        <v-spacer></v-spacer>        
      </v-card-actions>          
    </v-card>


    <v-card v-else-if="setFoundForThisHour==2" class="mx-auto" max-width="550">
      <v-row class="d-flex justify-center align-center text-h5 text-center ma-1 pa-1 grey--text">
      {{currentHour}}:00 Set: {{ this.setForThisHour.title }} 
      </v-row>
      <v-divider></v-divider>
     <v-list subheader two-line>
        <v-list-item
          v-for="exercise in this.setForThisHour.exercises"
          :key="exercise.title"
          class="pl-10"
        >
          <v-list-item-avatar>
              <img :src="exercise.icon" alt="Item Icon" width="24" height="24">
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="exercise.title"></v-list-item-title>
            <v-list-item-subtitle v-text="exercise.subtitle"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- Countdown slider -->
      <div> 
        <v-progress-linear
        v-model="progressCountdown"
        color="blue-grey"
        height="40"
        >
        Set about to start
      </v-progress-linear>
    </div>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="pink darken-2 white--text" @click="$router.push('/sets')">Select a different session</v-btn>
        <v-spacer></v-spacer>        
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="pink darken-2 white--text" @click="$router.push('/home')">Cancel</v-btn>
        <v-spacer></v-spacer>        
      </v-card-actions>          
    </v-card>


   <v-card v-else class="mx-auto" max-width="550">
        <v-row class="d-flex justify-center align-center text-h5 text-center ma-1 pa-1 grey--text">
        {{currentHour}}:00 - No Set Found 
        </v-row>
        <v-row class="d-flex justify-center align-center text-body-1 text-center ma-1 pa-1 grey--text">
        Scheduled Sets run Monday through to Friday 
        </v-row>
        <v-row class="d-flex justify-center align-center text-body-1 text-center ma-1 pa-1 grey--text">
        and at {{this.scheduledHours[0]['08']}} through to {{this.scheduledHours[this.scheduledHours.length - 1]['17']}}
        </v-row>



        <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="pink darken-2 white--text" @click="$router.push('/sets')">Select a session</v-btn>
        <v-spacer></v-spacer>        
      </v-card-actions>        
  </v-card>

  </v-container>
</template>






<style>
.v-progress-circular {
margin: 1rem;
}
</style>



<script>
import { Auth } from 'aws-amplify'  
import queries from '../api/queries'
import moment from 'moment'
import { SCHEDULED_HOURS } from '../services/constants';
export default {

  name: 'Sets',

  data: () => ({

    scheduledHours: SCHEDULED_HOURS,
    displaySchedule: [], // we build this for display
    setList: [],  // the list of current Sets
    setForThisHour: [],
    currentHour: null,
    totalTime: 6000, // 5000 milliseconds (5 seconds)
    progressCountdown: 100,
    currentTime: 6000,
    countdown: 6,  
    setFoundForThisHour: 0, 
  
  }),
  async created() {


    this.currentHour=this.$route.query.hour
    console.log(typeof this.currentHour)
    console.log("HOUR")
    console.log(this.currentHour)
    this.userAuthData = await Auth.currentUserInfo();
     
    this.setList = await queries.listSetExercisesForOwnerAndMicrocise(this.userAuthData.username); // a custom query

 
    // get list of both Microcise and User defined exercises
    // add users sets to the list....
    let userSetList =await queries.listSetExercisesWithFilter(this.userAuthData.username);

    for(let i=0;i<userSetList.length;i++) {
      this.setList.push(userSetList[i])
    }

    // Get the combined Schedule - User Schedule and Default Schedule combined
    // Setlist is needed to lookup some of the Set details
    this.displaySchedule = await queries.getUsersSchedule(this.scheduledHours, this.setList)


    //
    // If the hour was not passed in as a parameter, get the current hour
    if (typeof this.currentHour === 'undefined' || this.currentHour===null) {
      console.log("HOUR is empty......")
      // Get local time so we can find the scheduled Set
      const localTime = moment();

      // Get the hour in 24-hour format (0-23)
      this.currentHour = localTime.format('HH');
    }



    this.setForThisHour = this.displaySchedule.find(entry => entry.hour === this.currentHour);

    if (typeof this.setForThisHour === 'object' && this.setForThisHour !== null) {
      this.setFoundForThisHour=2
      this.startTimer();
    } else {
       this.setFoundForThisHour=1
    }

  },

  methods: {
    goTo(destination) {
      this.$router.push({ path: destination })
    },
    startTimer() {



      const interval = 100; // Update the timer every 100 milliseconds
      const timer = setInterval(() => {
        this.currentTime -= interval;
        this.countdown = (this.currentTime / 1000).toFixed(1); // Display with one decimal place
        this.progressCountdown=(this.currentTime / this.totalTime) * 100

        if (this.currentTime <= 0) {
          clearInterval(timer); // Stop the timer when it reaches 0
          const currentRoutePath = this.$route.path;
          console.log("Current route path: ", currentRoutePath);

          //
          // THIS IS BRITTLE!
          //
            if(currentRoutePath == '/setcountdown') {
            this.timerComplete(); // Call the method when the countdown completes
          } else {
            console.log("TIMER COMPLETE - NO ACTION")
          }
        }
      }, interval);
    },
    timerComplete() {
      // Your code to execute when the countdown has completed
      this.goToSession()

      //https://app.microcise.co.uk/#/session?setID={0}
    },


      goToSession() {

        this.$router.push({ path: 'session', query: { setID: this.setForThisHour.setID } })
      }      
  }          
}
</script>


<style scoped>
.timer-countdown {
  text-align: center;
  font-size: 24px;
  margin-top: 16px;
  color: #007acc; /* Adjust the color as needed */
}
</style>

